import clsx from 'clsx';
import React from 'react';
import { ThemeVariants } from '../../types';

export type BadgeProps = {
  variant: ThemeVariants<'primary' | 'secondary' | 'success' | 'warning' | 'danger' | 'info'>;
  block?: boolean;
  size?: 'small' | 'regular' | 'large';
  className?: string;
};

const common = 'inline-block rounded-lg font-bold text-center';

const sizes = {
  small: 'px-2 py-1 border-2 text-xs',
  regular: 'px-3 py-1 border-4 text-sm',
  large: 'px-4 py-1 border-4 text-lg',
};

const styleMap = {
  primary: 'bg-content-brand border-content-brand text-white',
  secondary: 'bg-content-secondary border-content-secondary text-white',
  success: 'bg-content-positive border-content-positive text-white',
  warning: 'bg-content-warning border-content-warning text-black',
  danger: 'bg-content-negative border-content-danger text-white',
  info: 'bg-content-informative border-content-informative text-white',
};

function Badge({ variant, block, size = 'regular', children, className }: React.PropsWithChildren<BadgeProps>) {
  return (
    <span className={clsx(common, styleMap[variant], block && 'block w-full', sizes[size], className)}>{children}</span>
  );
}

export { Badge };
